import './index.css';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import PhotoGallery from './components/PhotoGallery';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import MuiAlert from '@mui/material/Alert';
import { projectAuth } from './firebase/config';
import { signOut } from "firebase/auth";
import AuthModal from './components/AuthModal';
import AboutPage from './components/AboutPage';
import ImageGrid from './components/ImageGrid';
import PhotoGear from './components/PhotoGear';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#6ecabe',
    },
    secondary: {
      main: '#11cb5f',
    },
    tertiary: {
      main: '#eb6596',
    },
  },
});

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#6ecabe',
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: 'rgba(255, 255, 255, 0.7)',
    '&.Mui-selected': {
      color: '#6ecabe',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }),
);

const Input = styled('input')({
  display: 'none',
});

function Ninadgram() {

  const [value, setValue] = React.useState(0);
  const [file, setFile] = useState(null);
  const [successAlert, setSuccessAlert] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleImageUpload = (event) => {
    let selectedFile = event.target.files[0];
    console.log(selectedFile);

    if (selectedFile) {
      setFile(selectedFile);
      setSuccessAlert(false);
    } else {
      setFile(null);
    }
  };

  const handleAlertClose = () => {
    setSuccessAlert(false);
  }

  const handleAuthModalOpen = () => {
    setAuthModalOpen(!authModalOpen);
  }

  const logout = async () => {
    try {
      await signOut(projectAuth);
      setLoggedIn(false);
      setUsername("");
      setUserEmail("");
      return (1);
    } catch (error) {
      return (0);
    }
  }

  return (
    <div className="App">
      <h1 className='heading'>ninadgram</h1>
      {loggedIn ? <div><p>Welcome, {username}</p>
        <Button sx={{
          color: 'black',
          backgroundColor: '#6ecabe',
          textTransform: 'none',
          border: '2px solid #6ecabe',
          '&:hover': {
            backgroundColor: '#0E0E10',
            color: '#6ecabe',
          }
        }} className='auth-btn' variant="contained" endIcon={<LockOpenIcon />} onClick={logout}>logout</Button></div> :
        <Button sx={{
          color: 'black',
          backgroundColor: '#6ecabe',
          textTransform: 'none',
          border: '2px solid #6ecabe',
          '&:hover': {
            backgroundColor: '#0E0E10',
            color: '#6ecabe',
          }
        }} className='auth-btn' variant="contained" endIcon={<LockIcon />} onClick={handleAuthModalOpen}>login</Button>}
      <AuthModal
        authModalOpen={authModalOpen}
        handleAuthModalOpen={handleAuthModalOpen}
        setUsername={setUsername}
        setLoggedIn={setLoggedIn}
        setUserEmail={setUserEmail}
      />
      <ThemeProvider theme={theme}>
        <Box sx={{ marginTop: '2%' }}>
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="ninadgram-tabs-primary"
            centered
          >
            <StyledTab label="pictures" {...a11yProps(0)} />
            <StyledTab label="projects" {...a11yProps(1)} />
            <StyledTab label="about" {...a11yProps(2)} />
          </StyledTabs>
          <TabPanel value={value} index={0}>
            <div className='photo-gallery-div'>
              {loggedIn && userEmail === 'shenoyninad@gmail.com' && <label htmlFor="upload-image-btn">
                <Input accept="image/*" id="upload-image-btn" type="file" onChange={handleImageUpload} />
                <Button sx={{
                  color: 'black',
                  backgroundColor: '#6ecabe',
                  textTransform: 'none',
                  border: '2px solid #6ecabe',
                  '&:hover': {
                    backgroundColor: '#0E0E10',
                    color: '#6ecabe',
                  }
                }} className='auth-btn' variant="contained" component="span" endIcon={<AddAPhotoIcon />}>add photo</Button>
              </label>}

              {file && <PhotoGallery file={file} setFile={setFile} setSuccessAlert={setSuccessAlert} />}
              <p>shot on</p>
              <PhotoGear />
              <ImageGrid />
              <Snackbar open={successAlert} onClose={handleAlertClose} autoHideDuration={4000}>
                <Alert onClose={handleAlertClose} variant="filled" severity="success" sx={{ width: '100%' }}>
                  The image has been successfully uploaded
                </Alert>
              </Snackbar>
            </div>

          </TabPanel>
          <TabPanel value={value} index={1}>
            <p>Will be connected to my GitHub account very shortly!</p>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <AboutPage />
          </TabPanel>
        </Box>
      </ThemeProvider>
    </div >
  );
}

export default Ninadgram;
